import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProductProfileState {
    selectedView: string;
}

const initialState: ProductProfileState = {
    selectedView: 'info',
};

const productProfileSlice = createSlice({
    name: 'productProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        }
    },
});

export const { setSelectedView } = productProfileSlice.actions;
export default productProfileSlice.reducer;
